<template>
  <LayoutDefault>
    <div
            class="container dark"
            id="dashboard"
    >
      <template v-if="$auth.ready() && $auth.check()">
        <div class="blocks">
          <section class="block personal-data">
            <p>
              {{$auth.user().email}}
            </p>
            <p>
              {{$t('dashboard.member_since', {date: $d(new Date($auth.user().created_at), 'short')})}}
            </p>
            <p>
              <router-link class="membership-link" :to="{name: 'membership'}">
                {{$t('dashboard.subscription_status')}}
              </router-link>
            </p>
          </section>
        </div>

<!--        <section-->
<!--                class="favorited-movies"-->
<!--        >-->
<!--          <h3 class="title">-->
<!--            {{$t("dashboard.favorited_movies")}}-->
<!--          </h3>-->

<!--          <ResourceScroller :resource="favoritedMoviesScroller.resource"-->
<!--                            :default-params="favoritedMoviesScroller.defaultParams"-->
<!--                            :per-page="8"-->
<!--          >-->
<!--            <template slot-scope="{element}">-->
<!--              <ResourceScrollerMovieBox :movie="element"/>-->
<!--            </template>-->
<!--            <template slot="placeholder" slot-scope="data">-->
<!--              <ResourceScrollerMovieBox :placeholder="true"/>-->
<!--            </template>-->
<!--          </ResourceScroller>-->
<!--        </section>-->

<!--        <section-->
<!--                class="liked-movies"-->
<!--        >-->
<!--          <h3 class="title">-->
<!--            {{$t("dashboard.liked_movies")}}-->
<!--          </h3>-->

<!--          <ResourceScroller :resource="likedMoviesScroller.resource"-->
<!--                            :default-params="likedMoviesScroller.defaultParams"-->
<!--                            :per-page="8"-->
<!--          >-->
<!--            <template slot-scope="{element}">-->
<!--              <ResourceScrollerMovieBox :movie="element"/>-->
<!--            </template>-->
<!--            <template slot="placeholder" slot-scope="data">-->
<!--              <ResourceScrollerMovieBox :placeholder="true"/>-->
<!--            </template>-->
<!--          </ResourceScroller>-->
<!--        </section>-->
      </template>
    </div>
  </LayoutDefault>
</template>

<script>
    // import VideoBox from "../components/VideoBox";
    import Spinner from "../components/Spinner";
    import ResourceTable from "../components/ResourceTable";
    import resources from '../resources';
    import EventBus from '../eventbus';
    // import ResourceScroller from "../components/ResourceScroller";
    // import ResourceScrollerMovieBox from "../components/ResourceScroller.MovieBox";
    import RecurringStatusTable from '../components/RecurringStatusTable';
    import LayoutDefault from "../layouts/LayoutDefault";
    import FullBackdrop from "../components/FullBackdrop";

    export default {
      components: {
        LayoutDefault,
          // ResourceScroller,
          // VideoBox,
          Spinner,
          ResourceTable,
          // ResourceScrollerMovieBox,
          RecurringStatusTable,
          FullBackdrop
      },
      data(){
        return {
            user: null,
        }
      },
      computed: {
          favoritedMoviesScroller(){
              return {
                  resource: resources.movies,
                  defaultParams: {
                      include: [],
                      favorited: true
                  },
              };
          },
          likedMoviesScroller(){
              return {
                  resource: resources.movies,
                  defaultParams: {
                      include: [],
                      liked: true
                  },
              };
          },
      },
    }
</script>

<style scoped lang="scss">
  @import '../styles/variables';
  @import '../styles/classes';

  #dashboard{
    box-sizing: border-box;
    min-height: 500px;
    padding: 9px;

    .banners{
      .banner{
        height: 400px;
        background-size: cover;
        background-position: center;
      }
    }


    .favorited-movies{

      min-height: 200px;

      .movie{
        width: 200px;

        &.horizontal{
          width: 500px;
        }
      }
    }

    .liked-movies{

      min-height: 200px;

      .movie{
        width: 200px;

        &.horizontal{
          width: 500px;
        }
      }
    }

    .blocks{
      //display: block;
      //margin-bottom: 100px;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100%;
      min-height: 500px;
      
      .block.personal-data{
        text-align: center;
        flex-basis: 50%;
      }
    }

    .membership-link{
      color: $pallete_main_color;
    }
  }
</style>